module.exports = __webpack_public_path__ + "img/newtwitter.59c9b3e5.svg";